import { createSlice } from '@reduxjs/toolkit';
import { getCurrentUser } from 'src/services/UserService';
import { setInstanceAuthorization } from 'src/utils/AxiosInstance';

export const authSlice = createSlice({
  name: 'auth',
  initialState: {
    access_token: null,
    user_key: null,
    role: null,
    full_name: null,
    partner_id: null,
    broker_id: null,
  },
  reducers: {
    signInStore: (state, action) => {
      const { access_token, user_key, role, full_name, partner_id, broker_id } = action.payload;
      state.access_token = access_token;
      state.user_key = user_key;
      state.role = role;
      state.full_name = full_name;
      state.partner_id = partner_id;
      state.broker_id = broker_id;
    },
    signOutStore: (state) => {
      state.access_token = null;
      state.user_key = null;
      state.role = null;
      state.full_name = null;
      state.partner_id = null;
      state.broker_id = null;
    },
  },
});

export const { signInStore, signOutStore } = authSlice.actions;

export const isAuthenticated = (state) =>
  state.auth.user_key && state.auth.access_token ? true : false;

export const getCurrentUserDetail = (access_token) => async (dispatch) => {
  try {
    const { id, role, full_name, partner_id, broker_id } = await getCurrentUser(access_token);
    // Set header authorization axios instance
    setInstanceAuthorization(id);
    dispatch(
      signInStore({
        access_token,
        user_key: id,
        role,
        full_name,
        partner_id: partner_id,
        broker_id: broker_id,
      })
    );
  } catch (error) {
    throw error;
  }
};

export default authSlice.reducer;
